(function () {
  'use strict';

  const overlay = document.getElementById('showroomVideoModal');
  if (!overlay) return;

  const stepChoose = document.getElementById('svmStepChoose');
  const stepDetail = document.getElementById('svmStepDetail');
  const titleEl = document.getElementById('svmShowroomTitle');
  const video = document.getElementById('svmVideo');
  const videoSource = document.getElementById('svmVideoSource');
  const productsContainer = document.getElementById('svmProducts');
  const closeBtn = overlay.querySelector('.svm-close');
  const backBtn = overlay.querySelector('.svm-back');
  const optionBtns = overlay.querySelectorAll('.svm-option');

  const config = window.showroomVideoModalConfig || {};
  const productCache = {};

  /* ---- Open / Close ---- */
  function openModal() {
    overlay.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    resetToStep1();
  }

  function closeModal() {
    overlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (video) {
      video.pause();
      video.currentTime = 0;
    }
  }

  function resetToStep1() {
    stepChoose.hidden = false;
    stepDetail.hidden = true;
    if (video) {
      video.pause();
      video.currentTime = 0;
    }
  }

  /* ---- Fetch product by SKU using Shopify search ---- */
  function fetchProductBySku(sku) {
    if (productCache[sku]) return Promise.resolve(productCache[sku]);

    return fetch('/search/suggest.json?q=' + encodeURIComponent(sku) + '&resources[type]=product&resources[limit]=1')
      .then(function (res) { return res.json(); })
      .then(function (data) {
        var products = data.resources && data.resources.results && data.resources.results.products;
        if (products && products.length > 0) {
          var p = products[0];
          var result = {
            title: p.title,
            url: p.url,
            image: p.image,
            price: p.price
          };
          productCache[sku] = result;
          return result;
        }
        return { title: sku, url: '', image: '', price: '' };
      })
      .catch(function () {
        return { title: sku, url: '', image: '', price: '' };
      });
  }

  /* ---- Select showroom ---- */
  function selectShowroom(key) {
    var data = config[key];
    if (!data) return;

    titleEl.textContent = data.title;

    // Set video
    if (videoSource && video) {
      videoSource.src = data.video;
      videoSource.type = data.videoType || 'video/mp4';
      video.load();
    }

    // Show loading state
    productsContainer.innerHTML = '<p style="color:#888;font-size:14px;">Loading products...</p>';

    // Fetch products by SKU
    var skus = data.skus || [];
    Promise.all(skus.map(fetchProductBySku)).then(function (products) {
      renderProducts(products);
    });

    // Switch step
    stepChoose.hidden = true;
    stepDetail.hidden = false;
  }

  /* ---- Render product cards ---- */
  function renderProducts(products) {
    productsContainer.innerHTML = '';

    products.forEach(function (product) {
      var card;

      if (product.url) {
        card = document.createElement('a');
        card.href = product.url;
        card.className = 'svm-product-card';
        card.title = product.title || '';
      } else {
        card = document.createElement('div');
        card.className = 'svm-product-card svm-product-card--placeholder';
      }

      var img = document.createElement('img');
      img.className = 'svm-product-card__image';
      img.alt = product.title || '';
      img.loading = 'lazy';
      img.src = product.image
        ? product.image
        : 'data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="200" height="200"><rect fill="%23eee" width="200" height="200"/></svg>';

      card.appendChild(img);
      productsContainer.appendChild(card);
    });
  }

  /* ---- Event listeners ---- */
  closeBtn.addEventListener('click', closeModal);
  backBtn.addEventListener('click', resetToStep1);

  overlay.addEventListener('click', function (e) {
    if (e.target === overlay) closeModal();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && overlay.getAttribute('aria-hidden') === 'false') {
      closeModal();
    }
  });

  optionBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var showroom = btn.getAttribute('data-showroom');
      selectShowroom(showroom);
    });
  });

  /* ---- Trigger: intercept flex banner click ---- */
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-showroom-video-trigger]');
    if (trigger) {
      e.preventDefault();
      openModal();
    }
  });

  /* Expose for external use */
  window.openShowroomVideoModal = openModal;
})();
